import React from 'react';
import Reflux from 'reflux';
import GongqiFormItem from './GongqiFormItem';
import FormItemConst from './FormItemConst';
import ToolBarPrintStore from '../stores/ToolBarPrintStore';
import {FocusSetStore} from '../stores/FocusStore';
import FocusActions from '../actions/FocusActions';
import {CmdUpdateControlAllowEditStore,DsAllowEditStore,CmdUpdateControlLabelStore} from '../stores/CmdTypeStore';
import {CmdButtonOk,SetButtonStyleStore,SetTextStyleStore,CmdWriteControlStore} from '../stores/CmdTypeStore';
import FormItemUtil from '../utils/FormItemUtil';

class FormItemText extends GongqiFormItem
{
	constructor(props) {
		super(props);
		this.unsubscribeSetTextStyleStore = SetTextStyleStore.listen(this.onSetTextStyle.bind(this));
		this.unsubscribeCmdUpdateControlLabelStore = CmdUpdateControlLabelStore.listen(this.onCmdUpdateControlLabel.bind(this));
		this.unsubscribeCmdWriteControlStore = CmdWriteControlStore.listen(this.onCmdWriteControlStore.bind(this));
		let _label = this.props.initEditorValue?this.props.initEditorValue:this.props.label;
		this.state = Object.assign(this.state,{
			displayLength:this.props.displayLength,
			displayHeight:this.props.displayHeight,
			alignMent:this.props.alignMent,
			alignBase:this.props.alignBase,
			label:_label
		});

		let textStyles = this.getTextStyles();
		if(textStyles)
			this.state.devStyles = Object.assign({},textStyles);
		else
			this.state.devStyles = {};

		let displayStyle = this.getProperty_DisplayStyle();
		if(displayStyle)
			this.state.displayStyle = Object.assign({},displayStyle);
		/*let textStyles = this.getTextStyles();
		if(textStyles)
		{
			let devStyles = {};
			for(let key in textStyles)
			{
				if(key != "map")
					devStyles[key] = textStyles[key];
			}
			this.state = Object.assign(this.state,devStyles);
			devStyles = {};

			for(let key in textStyles.map)
			{
				devStyles[key] = textStyles.map[key];
			}
			this.state.devStyles = devStyles;
		}*/
	}

	componentWillUnmount()
	{
		this.unsubscribeSetTextStyleStore();
		this.unsubscribeCmdUpdateControlLabelStore();
	}

	onCmdUpdateControlLabel(name,_label,moduleInstanceId)
	{
		if(name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.setState({label:_label});
		}
	}

	getTextStyles()
	{
		let menuItemId = this.props.menuItemId;
		let formId = this.props.formId;
		let innerId = this.props.xml.id;
		return FormItemUtil.getControlStyles(menuItemId,formId,innerId);
	}
	getProperty_DisplayStyle()
	{
		if(this.props.xml.Properties.DisplayStyle && this.props.xml.Properties.DisplayStyle.Value){
			return this.props.xml.Properties.DisplayStyle.Value;
		}
		return '';
	}

	getProperty_Alignment()
	{
		let dis = this.getProperty_DisplayStyle();
		if(dis){
		let displayStyle = JSON.parse(dis);

		if(displayStyle && displayStyle.HorizontalAlignment)
			return displayStyle.HorizontalAlignment;
		}
		return "";
	}

	getProperty_VAlignment()
	{
		let dis = this.getProperty_DisplayStyle();
		if(dis){
			let displayStyle = JSON.parse(dis);
			if(displayStyle && displayStyle.VerticalAlignment)
				return displayStyle.VerticalAlignment;
		}
		return "";
	}

	getProperty_CSSStyle_Display()
	{
		let dis = this.getProperty_DisplayStyle()
		if(dis){
			let displayStyle = JSON.parse(dis);
			if(displayStyle && displayStyle.cssStyle)
				return displayStyle.cssStyle;
		}
		return "";
	}

	onSetTextStyle(formId,name)
	{
		if(this.props.xml.name == name && this.props.formId == formId)
		{
			let textStyles = this.getTextStyles();
			if(textStyles)
				this.setState({devStyles:textStyles});
		}
	}

	componentDidMount()
	{
		//$(this.textField).html(this.state.label);
	}

	componentDidUpdate()
	{
		//$(this.textField).html(this.state.label);	
	}

	onCmdWriteControlStore(arg,moduleInstanceId)
	{
		if(arg && arg.hasOwnProperty(this.props.xml.name) && this.props.moduleInstanceId == moduleInstanceId)
		{
			var value = arg[this.props.xml.name];
			this.setState({label:value});
		}
	}

	render()
	{
		let _style = Object.assign({},this.props.customStyle);
		let displayLength=this.state.displayLength;
		let cssStyle = this.getProperty_CSSStyle_Display();
		let VerticalAlignment = this.getProperty_VAlignment();
		let HorizontalAlignment = this.getProperty_Alignment();
		if(!_style)_style = {};
		
		if(!_style.width)
		{
			let _width=displayLength*FormItemConst.displayLength_CH+'px';
			_style.width = _width;
		}
		
		if(this.state.visible == false)
		{
			if(this.state.hideInVisible == true) _style.display="none"; else _style.visibility="hidden";
		}


		if(this.state.color && this.state.color != -1)_style.color = this.state.color;
		if(this.state.backgroundColor && this.state.backgroundColor != -1)_style.backgroundColor = this.state.backgroundColor;
		if(this.state.fontSize && this.state.fontSize != -1)_style.fontSize = this.state.fontSize;
		if(this.state.fontFamily)_style.fontFamily = this.state.fontFamily;
		if(this.state.fontWeight)_style.fontWeight = this.state.fontWeight;
		//displayStyle 属性设置
		if(cssStyle.fontFamily)_style.fontFamily = cssStyle.fontFamily;
		if(cssStyle.color)_style.color = cssStyle.color;
		if(cssStyle.fontSize)_style.fontSize = cssStyle.fontSize+"px";
		if(cssStyle.fontStyle)_style.fontStyle = cssStyle.fontStyle;
		if(cssStyle.fontWeight)_style.fontWeight = cssStyle.fontWeight;
		if(VerticalAlignment){_style.display = "flex";_style.alignItems=VerticalAlignment}
		if(HorizontalAlignment){_style.display = "flex";_style.justifyContent=HorizontalAlignment;}

		if(this.state.devStyles)Object.assign(_style,this.state.devStyles);
		return <div className={"GongqiFormItemText"} id={this.props.xml.name} ref={node => this.textField = node} style={_style} dangerouslySetInnerHTML={{__html:this.state.label}}></div>
	}
	
};

FormItemText.defaultProps = {
};

export default FormItemText;


// WEBPACK FOOTER //
// ./src/formItem/FormItemText.js